import React, { PropTypes } from 'react'

import data from '../../../../core/data';
import BlogWrapper from './BlogWrapper';

class TheDifference extends React.Component {
  render () {
    return (
      <BlogWrapper>
        <h1>{ data.news[2].heading }</h1>
        <img src={ data.news[2].image } />
        { data.news[2].body }
      </BlogWrapper>
    )
  }
}

export default TheDifference;



/** WEBPACK FOOTER **
 ** ./src/components/containers/news/blogs/TheDifference.jsx
 **/